import styled, { css, keyframes } from 'styled-components';

const rotateAnimation = keyframes`
  100% { 
    transform:rotate(360deg); 
  }
`;

export const Wrap = styled.div`
  width: 120vw;
  height: 120vw;
  position: fixed;
  overflow: hidden;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);

  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Dot = styled.div<{ $initialAngle: number; $diameter: number }>`
  position: absolute;
  width: 70px;
  height: 70px;
  ${({ $initialAngle, $diameter }) => {
    // Point on circle: 𝑥=𝑟sin𝜃 , 𝑦=𝑟cos𝜃.
    const r = $diameter / 2;
    const initialAngleRadians = ($initialAngle * Math.PI) / 180;
    const [x, y] = [
      Math.floor(r * Math.sin(initialAngleRadians) * 100) / 100,
      Math.floor(r * Math.cos(initialAngleRadians) * 100) / 100,
    ];

    return css`
      left: ${r - x}px;
      top: ${r - y}px;
    `;
  }}
  border-radius: 100px;
  background: #fff center center;
  background-size: 85%;
  box-shadow: inset 1px 1px 2px 0 rgba(0, 0, 0, 0.2);

  margin-top: -35px;
  margin-left: -35px;
  & > .ant-avatar {
    display: flex;
    width: 100%;
    height: 100%;
  }
`;

export const DotOrbit = styled.div<{
  $diameter: number;
  $duration: `${string}s`;
  $direction: 1 | -1;
}>`
  position: absolute;

  border: 1px solid #b38ef3;
  border-radius: ${({ $diameter }) => $diameter}px;
  width: ${({ $diameter }) => $diameter}px;
  height: ${({ $diameter }) => $diameter}px;

  animation: ${rotateAnimation} ${({ $duration }) => $duration}${({
  $direction,
}) => ($direction > 0 ? '' : ' reverse')} linear infinite; linear infinite;
  
    & ${Dot} {
      animation: ${rotateAnimation} ${({ $duration }) => $duration}${({
  $direction,
}) => ($direction > 0 ? ' reverse' : '')} linear infinite;
    }
`;
